/** Normalize axios body ({ success, data }) or raw array. */
export function parseApiData(response, fallback = []) {
  if (response == null) return fallback;
  if (Array.isArray(response)) return response;
  if (response.success === false) {
    return fallback;
  }
  if (Array.isArray(response.data)) return response.data;
  if (response.data && Array.isArray(response.data.data)) return response.data.data;
  if (response.data && Array.isArray(response.data.items)) return response.data.items;
  if (response.data && Array.isArray(response.data.targets)) return response.data.targets;
  if (response.data && Array.isArray(response.data.agents)) return response.data.agents;
  const nested = response.data;
  if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
    return fallback;
  }
  return Array.isArray(nested) ? nested : fallback;
}

export function parseApiError(response, fallbackMessage = 'Request failed') {
  if (!response || typeof response !== 'object') return null;
  if (response.success === false) {
    return response.message || fallbackMessage;
  }
  return null;
}

/** GET /alerts/logs — axios interceptor already unwraps to { success, data, total }. */
export function parseAlertLogsResponse(response) {
  if (response == null) return { rows: [], total: 0 };
  if (response.success === false) return { rows: [], total: 0 };
  if (Array.isArray(response.data)) {
    return {
      rows: response.data,
      total: Number(response.total) >= 0 ? Number(response.total) : response.data.length,
    };
  }
  if (Array.isArray(response)) {
    return { rows: response, total: response.length };
  }
  return { rows: [], total: 0 };
}
